<template>
  <details
    :class="[
      ns.b(),
      ns.is('active', isActive),
      ns.is('disabled', disabled)
    ]"
    :open="isActive"
  >
    <div v-show="collapse!.lineStyle && isActive" class="sg-collapse-item__line" :style="lineStyle"></div>
    <summary
      class="sg-collapse-item__header"
      :class="[`arrow-${collapse!.arrowPosition}`]"
      :tabindex="disabled ? -1 : 0"
      :style="collapse!.headerStyle"
      @click.prevent.stop="handleHeaderClick"
      @keyup.space.enter.stop="handleEnterClick"
    >
      <slot name="title">{{ title }}</slot>
      <sg-icon v-if="showArrow" class="sg-collapse-item__arrow">
        <ArrowRight />
      </sg-icon>
    </summary>
    <div class="sg-collapse-item__content" :style="collapse!.contentStyle">
      <slot></slot>
    </div>
  </details>
</template>
<script lang="ts">
import { defineComponent, inject, computed } from 'vue'
import { useNamespace } from '@sgui-plus/hooks'
import { generateId } from '@sgui-plus/utils/util'
import SgIcon from '@sgui-plus/components/icon'
import { ArrowRight } from '@sgui-plus/icons-vue'
import { CollapseContextKey } from './collapse.type'

import type { PropType } from 'vue'
import type { CollapseProvider } from './collapse.type'

export default defineComponent({
  name: 'SgCollapseItem',
  components: { SgIcon, ArrowRight },
  props: {
    title: {
      type: String,
      default: '',
    },
    name: {
      type: [String, Number] as PropType<string | number>,
      default: () => {
        return generateId()
      },
    },
    disabled: Boolean,
    showArrow: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const collapse = inject<CollapseProvider>(CollapseContextKey)

    const ns = useNamespace('collapse-item')

    const isActive = computed(() => {
      return collapse?.activeNames.value.indexOf(props.name) > -1
    })

    const lineStyle = computed(() => {
      return typeof collapse?.lineStyle === 'boolean' ? {} : collapse?.lineStyle
    })

    const handleHeaderClick = () => {
      if (props.disabled) return
      collapse?.handleItemClick(props.name)
    }

    const handleEnterClick = () => {
      if (props.disabled) return
      collapse?.handleItemClick(props.name)
    }

    return {
      isActive,
      lineStyle,
      handleHeaderClick,
      handleEnterClick,
      collapse,

      ns
    }
  },
})
</script>
